import { useTw } from '../../../../../../../../utils/Styles'
import { ConversationQuery } from '../../../Conversation.generated'
import { StaticRenderer } from '../../../../../../../../utils/StaticRenderer'
import {
  RootNodeInput,
  ConversationContentType,
} from '../../../../../../../../api/types'

type Event = ConversationQuery['Conversation']['messages'][0]

type MessageContentProps = { content: Event['content']; received: boolean }
export function MessageContent({ content, received }: MessageContentProps) {
  const tw = useTw()
  if (!content.message) return null

  return (
    <div
      className={tw`p-2 break-words text-sm rounded ${
        received ? 'bg-wild-strawberry-100' : 'bg-deep-purple-550'
      }`}
    >
      <StaticRenderer content={content.message as RootNodeInput} />
    </div>
  )
}

type ContentProps = { event: Event; received: boolean }
export function Content({ event, received }: ContentProps) {
  switch (event.content.type) {
    case ConversationContentType.Message:
      return <MessageContent received={received} content={event.content} />

    default:
      return null
  }
}
